export default "__VITE_PUBLIC_ASSET__93408c62__"